import { Component } from '@angular/core';
import { PlatformService } from '@panamax/app-state';
@Component({
  selector: 'app-zero-cost-info-popover',
  templateUrl: './zero-cost-info-popover.component.html',
  styleUrls: ['./zero-cost-info-popover.component.scss'],
})
export class ZeroCostInfoPopoverComponent {
  constructor(readonly platformService: PlatformService) {}
}
